export default __webpack_public_path__ + "static/media/carousel-prev.4bf9a510.svg";